import { render } from "./QuizSection.vue?vue&type=template&id=5a9f8932"
import script from "./QuizSection.vue?vue&type=script&lang=js"
export * from "./QuizSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__